import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`get/session-status/student-course-session/${courseSessionId}`, { params })
}
